export const enViewDishes = {
  navbarButton: "View dishes published",
  emptyList: "No dishes available",
  cleanFilters: "Clean filters",
  verifyLinkIsCorrect: "Verify the link is correct",
  noDescription: "No description",
  noEnglishTranslation: "No English translation",
  noSpanishTranslation: "No Spanish translation",
};
